interface ShieldCheckIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export default function ShieldCheckIcon({ width = 72, height = 85, className }: ShieldCheckIconProps) {
  // Calculate viewBox dimensions based on the original aspect ratio
  const aspectRatio = 85 / 72; // Original height/width ratio
  const viewBoxWidth = 72;
  const viewBoxHeight = viewBoxWidth * aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.4"
        d="M31.6665 1.07887L8.74984 9.6622C4.37484 11.3289 0.791504 16.4955 0.791504 21.2039V54.9539C0.791504 58.3289 2.99984 62.7872 5.70817 64.7872L28.6248 81.9122C32.6665 84.9539 39.2915 84.9539 43.3332 81.9122L66.2498 64.7872C68.9582 62.7455 71.1665 58.3289 71.1665 54.9539V21.2039C71.1665 16.5372 67.5832 11.3289 63.2082 9.70387L40.2915 1.12053C37.9582 0.203867 34.0415 0.203867 31.6665 1.07887Z"
        fill="url(#paint0_linear_shield_check)"
      />
      <path
        d="M30.4082 51.7949C29.6166 51.7949 28.8249 51.5033 28.1999 50.8783L21.4916 44.1699C20.9104 43.5818 20.5845 42.7884 20.5845 41.9616C20.5845 41.1348 20.9104 40.3413 21.4916 39.7533C22.6999 38.5449 24.6999 38.5449 25.9082 39.7533L30.4082 44.2533L46.1166 28.5449C47.3249 27.3366 49.3249 27.3366 50.5332 28.5449C51.7416 29.7533 51.7416 31.7533 50.5332 32.9616L32.6166 50.8783C31.9916 51.5033 31.1999 51.7949 30.4082 51.7949Z"
        fill="url(#paint1_linear_shield_check)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_shield_check"
          x1="64.1386"
          y1="42.3101"
          x2="8.77866"
          y2="40.3582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_shield_check"
          x1="48.3582"
          y1="39.7167"
          x2="24.1258"
          y2="38.4177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
